import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "actions/riskmedicalActions";
import Cart from "./Cart";
import { Loader } from "cxa-components";
import BenefitList from "./BenefitList";
import { injectIntl, intlShape } from "react-intl";
import { Prompt } from "react-router-dom";
import messages from "components/messagesDescription";
import { showPopup } from "actions/popupActions";

class RiskMedical extends Component {
  doRedirect(props) {
    if (props.saved && !props.isCheckout) {
      this.props.riskmedicalMarkEnrolmentAsDone();
      props.push("/shop/health-wellness");
    } else if (props.saved && props.isCheckout) {
      this.props.riskmedicalMarkEnrolmentAsDone();
      props.push("/shop/checkout");
    }
  }

  componentDidMount() {
    this.props.load();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.doRedirect(this.props);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    const { saved } = nextProps;

    if (saved) {
      this.doRedirect(nextProps);
    }
  }

  componentWillUnmount() {
    const { clean } = this.props;
    clean();
  }

  saveEnrolmentSelection = () => {
    const { save, selectionToSave, isShopEnabled } = this.props;
    save(selectionToSave, !isShopEnabled);
  };

  selectDefault = () => {
    const { selectDefaultLastAcceptedCover } = this.props;
    selectDefaultLastAcceptedCover(true);
  };

  render() {
    const { selectDefault, saveEnrolmentSelection } = this;
    const props = { ...this.props, selectDefault, saveEnrolmentSelection };
    const { enrolmentData, intl, isDirty, fetching } = this.props;
    const { accounts: { planStart } = {} } = enrolmentData || {};
    const currency = enrolmentData.clientSettings
      ? enrolmentData.clientSettings.currency
      : { symbol: "$" };

    return (
      <div>
        <div>{fetching && <Loader />}</div>
        <div className="grid__wrapper">
          <div className="grid__item grid__item--nine">
            <section>{!this.props.fetching && <BenefitList {...props} />}</section>
          </div>
          <div className="grid__item grid__item--three">
            {!fetching && (
              <Cart
                type="benefits"
                push={this.props.push}
                currency={currency}
                planStart={planStart}
              />
            )}
          </div>
          <Prompt
            when={!props.saving && !props.fetching && isDirty}
            message={() => intl.formatMessage({ ...messages.unSaveBenefitMessage })}
          />
        </div>
      </div>
    );
  }
}

RiskMedical.propTypes = {
  push: PropTypes.func,
  error: PropTypes.object,
  load: PropTypes.func,
  fetching: PropTypes.bool,
  clean: PropTypes.func,
  benefits: PropTypes.array,
  summary: PropTypes.object,
  save: PropTypes.func,
  selectDefaultLastAcceptedCover: PropTypes.func,
  selectionToSave: PropTypes.array,
  saving: PropTypes.bool,
  saved: PropTypes.bool,
  saveError: PropTypes.object,
  benefitsMap: PropTypes.object,
  enrolmentData: PropTypes.object,
  riskmedicalMarkEnrolmentAsDone: PropTypes.func,
  isShopEnabled: PropTypes.bool,
  history: PropTypes.object,
  intl: intlShape.isRequired,
  isDirty: PropTypes.bool.isRequired,
  helpSettings: PropTypes.object,
};

const mapStateToProps = store => {
  const {
    riskmedical,
    common,
    needhelp: { response },
  } = store;

  return {
    error: riskmedical.error,
    fetching: riskmedical.fetching || !riskmedical.response,
    benefits: riskmedical.benefits,
    summary: riskmedical.summary,
    response: riskmedical.response,
    selectionToSave: riskmedical.selectionToSave,
    saving: riskmedical.saving,
    saved: riskmedical.saved,
    saveError: riskmedical.error,
    benefitsMap: riskmedical.benefitsMap,
    isCheckout: riskmedical.isCheckout,
    enrolmentData: riskmedical.enrolmentData,
    isShopEnabled: common.isShopEnabled,
    isDirty: riskmedical.isDirty,
    helpSettings: response,
  };
};

const mapDispatchToProps = {
  ...actions,
  showPopup,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(RiskMedical));



// WEBPACK FOOTER //
// ./components/employee/shop/RiskMedicalPage.js